import romanApi from "@roman/shared/lib/net/romanApi";
import type { RankingRewardSlice } from "@roman/shared/types/RankingRewardSlice";
import useSWRInfinite, { type SWRInfiniteConfiguration } from "swr/infinite";

type ResponseRankingRewardSlice = {
  rankingRewardSlices: RankingRewardSlice[];
};

export type UseGetActiveLeaderboardRankProps = {
  leaderboardCycleId?: string;
  swrOptions?: SWRInfiniteConfiguration;
  fetcher?: (url: string) => Promise<ResponseRankingRewardSlice>;
};

const createDefaultGetRankingDistribution = () => {
  return (url: string) => romanApi.get<ResponseRankingRewardSlice>(url);
};

const getKey = (leaderboardCycleId?: string) => {
  if (!leaderboardCycleId) return null;
  return `/leaderboard/ranking-distribution/${leaderboardCycleId}`;
};

export const useGetRankingDistribution = ({
  leaderboardCycleId,
  swrOptions,
  fetcher,
}: UseGetActiveLeaderboardRankProps) => {
  const leaderboardFetcher = fetcher || createDefaultGetRankingDistribution();

  const options: SWRInfiniteConfiguration = {
    revalidateFirstPage: false,
    ...swrOptions,
  };

  const swrQuery = useSWRInfinite<ResponseRankingRewardSlice>(
    () => getKey(leaderboardCycleId),
    leaderboardFetcher,
    options,
  );

  const rankingRewardSlices = swrQuery.data?.flatMap((page) => page.rankingRewardSlices) ?? [];

  return {
    ...swrQuery,
    rankingRewardSlices,
  };
};
